import React, { Fragment } from 'react';
import * as defaultConst from '../../../../../../utils/clientConstant';
import commonUtil from '../../../../../../utils/commonUtil';



const TableHead = ({ lables }) => (
      <table className="tableRegisteredGifts certificadosDeRegalosTable">
          <thead className="rowLines">
            <tr>
              {/* {this.props.compareEventStatus(this.props.eventStatus, defaultConst.eventStatus.VALIDITY_OFF_ACTIVE) || this.props.compareEventStatus(this.props.eventStatus, defaultConst.eventStatus.CLOSED) ? null : <td>&nbsp;</td>} */}
              {/* <td>&nbsp;</td>
              <td className="headImgInner">&nbsp;</td> */}
              <td className="headarticleInner">{commonUtil.getLabel(lables.EventAdminPage, 'adminpage.regalosregistrados.articulo.label')}</td>
              <td className="headpriceAndQuant headPriceInner">
                {commonUtil.getLabel(lables.EventAdminPage, 'adminpage.regalosregistrados.price.label')}
                {/* <Link linkJSON={LinkJSONPrice}><span className="tooltip-container fontWeight600-fontSize14 pt-8 pb-8">{commonUtil.getLabel(lables.EventAdminPage, 'adminpage.regalosregistrados.price.label')}
                  <span className="tooltip-box">{commonUtil.getLabel(lables.EventAdminPage, 'adminpage.comparas.price.tooltip.label')}</span>
                </span>&nbsp;{priceOrder === 'Descending' ? <i className="icon-flecha_filtros_abajo" aria-hidden="true" /> : <i className="icon-flecha_filtros_arriba" aria-hidden="true" />}
                </Link> */}
              </td>
              <td className="headpriceAndQuant headQuantityInner">{commonUtil.getLabel(lables.EventAdminPage, 'adminpage.regalosregistrados.qty.label')}</td>
              {/* <td className="text-center headDetailInner tooltip-container fontWeight600-fontSize14 pt-8 pb-8">{commonUtil.getLabel(lables.EventAdminPage, 'adminpage.regalosregistrados.itemavailable.label')}
                <span className="tooltip-box">{commonUtil.getLabel(lables.EventAdminPage, 'adminpage.regalosregistrados.item.available.tooltip')}</span>
              </td> */}
              <td className="headaddressInner headDetailInner">
                {commonUtil.getLabel(lables.EventAdminPage, 'adminpage.regalosregistrados.address.label')}
                {/* <span className="tooltip-container fontWeight600-fontSize14 pt-8 pb-8"> {commonUtil.getLabel(lables.EventAdminPage, 'adminpage.regalosregistrados.address.label')}
                  <span className="tooltip-box">{commonUtil.getLabel(lables.EventAdminPage, 'adminpage.regalosregistrados.address.tooltip')}</span></span> */}
              </td>
              <td className="headdeliverymode headModalInner">
                {commonUtil.getLabel(lables.EventAdminPage, 'adminpage.regalosregistrados.deliverymode.label')}
                {/* <span className="tooltip-container fontWeight600-fontSize14 pt-8 pb-8">{commonUtil.getLabel(lables.EventAdminPage, 'adminpage.regalosregistrados.deliverymode.label')}
                  <span className="tooltip-box">{commonUtil.getLabel(lables.EventAdminPage, 'adminpage.regalosregistrados.deliverymode.tooltip')}</span></span> */}
              </td>
              <td className='headfavs-section'>&nbsp;</td>
            </tr>
          </thead>
        </table>
);



export default TableHead;
